import { PlusIcon } from '@phosphor-icons/react';
import { captureException } from '@sentry/react';
import { Button } from 'components/button/Button';
import { Formik } from 'components/form/formik';
import { Card } from 'components/Card';
import diff from 'object-diff';
import { useMemo } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

import { InputField } from '../../../../../components/input/InputField';
import { getDisplayError } from '../../../../../utils/get-display-error';
import { useAllGeneralSettings } from '../../../all-settings-context';
import { updateGeneralSettings } from '../../../models';

const truckDocumentReminderSchema = Yup.object().shape({
  truckDocumentReminderInterval: Yup.string().required('Vereist'),
});

interface ITruckDocumentReminderValues {
  truckDocumentReminderInterval: string;
}

/**
 * How many days before expiry the carrier's contacts get an email about an
 * expiring truck insurance / inspection document (transport email in CC).
 */
export const TruckDocumentReminderSection = () => {
  const { settings } = useAllGeneralSettings();

  const initialValues: ITruckDocumentReminderValues = useMemo(() => {
    return {
      truckDocumentReminderInterval: '' + settings.truckDocumentReminderInterval,
    };
  }, [settings]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={truckDocumentReminderSchema}
      onSubmit={async (values) => {
        try {
          const patch: Partial<typeof values> = diff(initialValues, values);
          const { truckDocumentReminderInterval } = patch;
          await updateGeneralSettings({
            truckDocumentReminderInterval: truckDocumentReminderInterval ? +truckDocumentReminderInterval : undefined,
          });
          toast.success('Instellingen aangepast');
        } catch (err: any) {
          captureException(err);
          toast.error('Kon instellingen niet aanpassen: ' + getDisplayError(err));
        }
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <form onSubmit={handleSubmit} className="grid gap-4">
            <Card title="Herinneringen">
              <InputField
                labelText="Vervallen trekker document herinnering email interval"
                type="number"
                name="truckDocumentReminderInterval"
              />
            </Card>

            <div>
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                iconLeft={<PlusIcon className="button-icon" />}
              >
                Pas instellingen aan
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
